import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "qualification-policy-builder",
  "data-testid": "qualification-policy-builder"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-2 text-left text-sm text-gray-500",
  "data-testid": "qualification-policy-builder-empty"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "+ Critério", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Grupo", -1)

import RuleBuilderGroup from '@/components/designSystem/RuleBuilder/RuleBuilderGroup.vue'
import type {
  RuleBuilderGroup as RuleBuilderGroupType,
  RuleBuilderRule
} from '@/components/designSystem/RuleBuilder/types'
import type {
  QualificationRuleGroup,
  QualificationRuleValue
} from '@/types/qualification-policy.types'

import CriterionEditor from './CriterionEditor.vue'
import { QUALIFICATION_RULE_BUILDER_CONFIG } from './policyModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyBuilder',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {




// O RuleBuilderGroup é genérico (`unknown`); a árvore editada é sempre a da qualificação.
const onGroup = (group: RuleBuilderGroupType<string, unknown>) =>
  emit('update:modelValue', group as QualificationRuleGroup)
const valueOf = (rule: unknown) => (rule as RuleBuilderRule<QualificationRuleValue | null>).value

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RuleBuilderGroup, {
      group: _ctx.modelValue,
      config: _unref(QUALIFICATION_RULE_BUILDER_CONFIG),
      "operator-label": "O médico precisa atender a",
      "onUpdate:group": onGroup
    }, {
      rule: _withCtx(({ rule, update, index }) => [
        _createVNode(CriterionEditor, {
          "model-value": valueOf(rule),
          "test-id": `qualification-criterion-${index}`,
          "onUpdate:modelValue": update
        }, null, 8, ["model-value", "test-id", "onUpdate:modelValue"])
      ]),
      _: 1
    }, 8, ["group", "config"]),
    (!_ctx.modelValue.children.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createTextVNode(" Nenhum critério. Use "),
          _hoisted_3,
          _createTextVNode(" para exigir um selo ou documento, ou "),
          _hoisted_4,
          _createTextVNode(" para combinar critérios com \"Qualquer um - OU\". ")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})